/*
 * The buttons config is meant to be a JSON array of keys, but the Admin
 * Features editor serialises values as plain strings, so it can come back as
 * '["CONTRACTOR","STAFF"]' (or a comma-separated list) instead of an array.
 * Coerce to an array so the consumer can always .filter() over it; return null
 * when there's nothing usable so the caller can fall back to the defaults.
 */
export const normalizeButtonKeys = (buttons) => {
  /* Return null (not an empty array) when there's nothing usable: [] is truthy,
     so the caller's `|| defaultBuzzoutButtons` fallback would never fire and no
     buttons would render. */
  if (Array.isArray(buttons)) return buttons.length ? buttons : null;
  if (typeof buttons === "string") {
    const trimmed = buttons.trim();
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) return parsed.length ? parsed : null;
    } catch (e) {
      // not JSON - fall through to comma-separated parsing
    }
    const keys = trimmed
      .split(",")
      .map((key) => key.trim().replace(/^["']|["']$/g, ""))
      .filter(Boolean);
    if (keys.length) return keys;
  }
  return null;
};
